<template>
  <div class="personal-deliver-page">
    <article class="panel-group" :key="tempKey">
      <section class="panel cargo-info panel-diff">
        <handling-wrapper ref="handlingWrapper" />
      </section>

      <section class="panel deliver-info">
        <h3 class="panel-header">费用信息</h3>
        <cost-info-wrapper ref="costInfo" />
      </section>

      <section class="panel deliver-note">
        <h3 class="panel-header">发货备注</h3>
        <transport-require ref="transportRequire" />
      </section>
    </article>

    <!-- <button
      class="btn btn-primary deliver-btn"
      @click="deliverHandler"
      :loading="true"
    >
      立即发货
    </button> -->
    <div class="deliver-btn-wrap">
      <el-button
        type="primary"
        class="deliver-btn"
        :loading="deliverLoading"
        @click="deliverHandler"
        >立即发货</el-button
      >
    </div>
  </div>
</template>

<script>
import Order from "@/models/Order";
import Goods from "@/models/Goods";
import HandlingWrapper from "./components/handlingWrapper";
import costInfoWrapper from "./components/costInfoWrapper";
import transportRequire from "./components/transportRequire";
import qs from "qs";

export default {
  name: "indexPage",
  data() {
    return {
      tempKey: new Date().getTime(),
      deliverLoading: false
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    getPostData() {
      let { notes, ...transportAsk } = this.$refs.transportRequire.ruleForm;
      let obj = {
        handling: Object.values(this.$refs.handlingWrapper.ruleForm),
        feeInfo: this.$refs.costInfo.ruleForm,
        transportAsk,
        other: {
          defaultOtherLabels: this.$refs.transportRequire.defaultOtherLabels,
          notes
        }
      };
      return {
        entrustOrder: JSON.stringify(obj)
      };
    },
    async doSubmit() {
      try {
        this.deliverLoading = true;
        await this.$http.post(
          "/shipper/order-shipper/create",
          qs.stringify(this.getPostData())
        );
        this.$message({
          type: "success",
          message: "发货成功!"
        });
        // this.tempKey = new Date().getTime();
        this.$router.push({ name: "order" });
      } catch (e) {
      } finally {
        this.deliverLoading = false;
      }
    },
    async deliverHandler() {
      try {
        await Promise.all([
          this.$refs.handlingWrapper.formValidate(),
          this.$refs.costInfo.formValidate()
        ]);
        this.doSubmit();
      } catch (e) {
        return false;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("goodsArr");
    next();
  },
  components: {
    HandlingWrapper,
    transportRequire,
    costInfoWrapper
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../../../style/_variable";

.panel-diff {
  padding-bottom: 10px !important;
}
.personal-deliver-page {
  padding-top: 52px;

  .cargo-info {
    .input-group {
      width: 49%;
      .input {
        width: 360px;
      }

      &.has-radio {
        .input {
          width: 240px;
        }
      }

      .address {
        width: 360px;
      }
    }
  }

  .deliver-note {
    .input-group {
      width: 100%;
      .input {
        width: 108px;
        margin: 0 5px 0 10px;
      }
      .textarea {
        display: inline-block;
        width: calc(100% - 100px);
        height: 60px;
        vertical-align: top;
        margin-left: 10px;
      }
    }
  }

  .cargo-info {
    .panel-goodsadded {
      .panel-inner-header {
        margin-bottom: 10px;
      }
    }
  }

  .add-goods-btn {
    display: block;
    width: 300px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    margin-top: 40px;
  }

  .deliver-btn-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    .deliver-btn {
      width: 364px;
      height: 48px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/index.vue